<template>
  <b-modal v-model="internalVisible" title="เปรียบเทียบสต๊อกจากไฟล์" size="xl" centered no-close-on-backdrop
    hide-footer @hidden="onHidden">
    <b-table id="compareStockFromFileTable" hover small responsive head-variant="light" :items="items" :fields="fields"
      :tbody-tr-class="getRowClass">
      <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
      <template v-slot:cell(image)="row">
        <ProductImage :src="row.item.imageUrl || null" />
      </template>
      <template v-slot:cell(productNo)="row">
        {{ row.item.productNo || "-" }}
      </template>
      <template v-slot:cell(productName)="row">
        {{ row.item.productName || "-" }}
      </template>
      <template v-slot:cell(adjustmentQty)="row">
        {{ formatAdjustQty(row.item.adjustmentQty) }}
      </template>
      <template v-slot:cell(totalQty)="row">
        <span :class="getTotalQtyClass(row.item)">
          {{ formatQty(row.item.totalQty) }}
        </span>
      </template>
      <template v-slot:cell(fileQty)="row">
        <span :class="getFileQtyClass(row.item)">
          {{ formatQty(row.item.fileQty) }}
        </span>
      </template>
      <template v-slot:cell(uomName)="row">
        {{ row.item.uomName || "-" }}
      </template>
    </b-table>

  </b-modal>
</template>

<script>
import ProductImage from "@/components/table/stock/component/ProductImage.vue";

export default {
  name: "CompareStockFromFileModal",
  components: { ProductImage },
  props: {
    visible: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      internalVisible: false,
      fields: [
        { key: "index", label: "", thStyle: { width: "60px" }, class: "text-center" },
        { key: "image", label: "", thStyle: { width: "60px", minWidth: "60px" } },
        { key: "productNo", label: "รหัส", thStyle: { minWidth: "100px" } },
        { key: "productName", label: "ชื่อสินค้า", thStyle: { minWidth: "160px" } },
        { key: "adjustmentQty", label: "จำนวนปรับปรุง", thStyle: { minWidth: "120px" }, class: "text-right" },
        { key: "totalQty", label: "จำนวนสต๊อกที่นับจริง", thStyle: { minWidth: "140px" }, class: "text-right" },
        { key: "fileQty", label: "จำนวนสต๊อกจากไฟล์", thStyle: { minWidth: "140px" }, class: "text-right" },
        { key: "uomName", label: "หน่วยสินค้า", thStyle: { minWidth: "100px" } },
      ],
    };
  },
  watch: {
    visible(val) {
      this.internalVisible = val;
    },
    internalVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    show() {
      this.internalVisible = true;
    },
    hide() {
      this.internalVisible = false;
    },
    onHidden() {
      this.$emit("update:visible", false);
    },
    formatAdjustQty(value) {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      const formatted = num.toLocaleString("en-US");
      return num > 0 ? `+${formatted}` : formatted;
    },
    formatQty(value) {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      return num.toLocaleString("en-US");
    },
    isMismatch(item) {
      return ["not_in_system", "not_in_file", "mismatch"].includes(item._type);
    },
    getRowClass(item, type) {
      if (type !== "row") return "";
      if (["not_in_system", "not_in_file"].includes(item._type)) return "row-not-found";
      if (item._type === "mismatch") return "row-mismatch";
      return "";
    },
    getTotalQtyClass(item) {
      return item._type === "not_in_system" ? "text-unmatch font-weight-bold" : "";
    },
    getFileQtyClass(item) {
      return this.isMismatch(item) ? "text-unmatch font-weight-bold" : "";
    },
  },
};
</script>

<style scoped>
::v-deep #compareStockFromFileTable thead th,
::v-deep #compareStockFromFileTable tbody td {
  vertical-align: middle !important;
}

::v-deep #compareStockFromFileTable tbody tr.row-mismatch td {
  background-color: #ffedee !important;
}

::v-deep #compareStockFromFileTable tbody tr.row-not-found td {
  background-color: #fffbe6 !important;
}

::v-deep #compareStockFromFileTable tbody tr:last-child td {
  border-bottom: 1px solid #dee2e6 !important;
}

.text-unmatch {
  color: #DD3333
}
</style>
